import styled from "styled-components";



const Loans = (props) => {
    return(
        <Container>
            <LoanCaption>
                <span>Knowledge of the market</span>
                <h2>Only the best professional services</h2>
                <p>At <b>Winnthako</b>, our services cuts across the following areas - SMEs loans, Students Loan, Personal Loans and Investment</p>
            </LoanCaption>
            <TypesOfLoans>
                <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2>SMEs. Loan</h2>
                    <p>Providing loans for Small/growing businesses is a priority at <b>Winnthako</b>.</p>
                    {/* <a href ="/LoanDetail">Learn More</a> */}
                </Card>
                <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2> Student Loan</h2>
                    <p>Supporting student in financing their education is our focus. As we have high regards for knowledge</p>
                    {/* <a href ="/LoanDetail">Learn More</a> */}
                </Card>
                <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2>Personal Loan</h2>
                    <p> Helping individuals solve their urgent financial needs is a big part of the company.</p>
                    {/* <a href ="/LoanDetail">Learn More</a> */}
                </Card>
                <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2>Investment</h2>
                    <p>Helping individuals and groups grow wealth is a standard and model at <b>Winnthako</b></p>
                    {/* <a href ="/LoanDetail">Learn More</a> */}
                </Card>
                {/* <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2>Education Loan</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                    <a href ="/LoanDetail">Learn More</a>
                </Card>
                <Card>
                    <div></div>
                    <span><i class="fa fa-university" aria-hidden="true"></i></span>
                    <h2>Payday Loan</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                    <a href ="/LoanDetail">Learn More</a>
                </Card> */}
            </TypesOfLoans>
        </Container>
    )

}

const Container = styled.div`
    background: rgb(249, 250, 251);
    text-align: center;
    padding: 50px 20px;
`
const LoanCaption = styled.div`
    span{
        color: rgb(231, 60, 62);
    }
`
const TypesOfLoans = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-wrap: wrap;


    @media(min-width: 768px){
        flex-direction: row;
        margin-top: 50px;
    }
`

const Card = styled.div`
    background: rgb(255, 255, 255);
    margin-bottom: 50px;
    padding: 50px 20px;
    position: relative;
    overflow: hidden;
    transition: 0.5s ease; 

    @media(min-width: 768px){
        width: 30%;

        h1{
            font-size: 25px;
        }

        p{
            line-height: 28.8px;
        }
    }

    &:hover { 
       transform: translateY(-20px);
       transition: transform 0.5s ease;

        
        div {
            background: rgb(231, 60, 62);
            color: rgb(255, 255, 255);
            transition: 0.5s ease;
           
        }
    }
    span{
        font-size: 40px;
        color: rgb(231, 60, 62);
        border-radius: 50%;
        background: white;
        padding: 25px 25px;
        position: relative;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        display: inline-block;

    }

    div{
        width: 90%;
        height: 80%;
        background: rgb(253, 235, 235);
        position: absolute;
        border-radius: 50%;
        top: -50%;
        left: 5%;

        @media(min-width: 768px){
            width: 98%;
            left: calc(2%/2);
            top: -55%;
        }
        
    
    }
    a{
        color: rgb(231, 60, 62);
    }
    
}
`



export default Loans